import getAddressFieldsConfig from 'jl-design-system/form/configs/address';
// lodash
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';

import {
  FIRST_NAME_DATA_STANDARDS,
  LAST_NAME_DATA_STANDARDS,
  SEARCH_FOR_ANOTHER_ADDRESS_BUTTON,
  POSTCODE,
} from 'jl-design-system/form/fields';
import { UnderlinedButton } from 'jl-design-system/elements/button/Button';
import { getPhoneNumberDropdownOptions } from '../../address/addressHelpers';
import titleFieldConfig from '../../features/titleDropdownUtil';
import { internationalPhoneNumberLazy } from '../../lazy/lazyMainBundle';

const INTERNATIONAL_PHONE_NUMBER = internationalPhoneNumberLazy;

export const DELIVERY_ADDRESS_FORM_ID = 'deliveryAddressForm';

export function getDeliveryAddressFormConfig(params) {
  const {
    addressLines,
    maxAddressLines,
    actions,
    configExtras,
    postcodeSearchFormVisible,
    editMode,
    enableGBCounty,
  } = params;

  const {
    searchForAnotherAddress,
  } = actions;

  const {
    changeAddressButton,
    autoFocusOnFirstField,
    useTitleDropdown,
  } = configExtras;

  const searchForAnotherAddressButton = {
    ...SEARCH_FOR_ANOTHER_ADDRESS_BUTTON,
    component: UnderlinedButton,
    props: {
      ...SEARCH_FOR_ANOTHER_ADDRESS_BUTTON.props,
      children: 'Search for another address',
      'data-test': 'search-for-address-button',
      onClick: searchForAnotherAddress,
    },
  };

  const renderAddressFields = !postcodeSearchFormVisible || editMode;

  const ADDRESS_FIELDS = renderAddressFields ? getAddressFieldsConfig({
    // when we get address fields we want GB fields even if country code is channel island e.g. GG, IM, JE
    countryCode: 'GB',
    addressLines,
    maxAddressLines,
    actions,
    configExtras,
    postcodeReadOnly: false,
    renderAddressFields,
    allowAsciiOnly: true,
    enableGBCounty,
  }) : [];

  if (!editMode && ADDRESS_FIELDS.length > 1) {
    const index = findIndex(ADDRESS_FIELDS, { id: POSTCODE.id });
    if (index >= 0) {
      ADDRESS_FIELDS[index].fieldExtra = searchForAnotherAddressButton;
    }
  }

  const config = INTERNATIONAL_PHONE_NUMBER();
  const PHONE_NUMBER = get(config, 'component') ? {
    ...config,
    instruction: 'We’ll send delivery updates by text to UK mobile numbers and call if we have any queries',
    props: {
      options: getPhoneNumberDropdownOptions(),
    },
  } : config;

  const titleField = titleFieldConfig(useTitleDropdown);

  if (autoFocusOnFirstField) {
    titleField.autoFocus = true;
  }

  return {
    id: DELIVERY_ADDRESS_FORM_ID,
    submitButton: 'Use this address',
    ...(changeAddressButton ? { submitButtonExtra: changeAddressButton } : {}),
    fields: [
      titleField,
      FIRST_NAME_DATA_STANDARDS,
      LAST_NAME_DATA_STANDARDS,
      PHONE_NUMBER,
      ...ADDRESS_FIELDS,
    ],
  };
}
